module.exports = __webpack_public_path__ + "static/media/caret.3e685c5b.svg";